export default __webpack_public_path__ + "static/media/gradient3.a8dd8f0d.png";